<template>
    <gofix-card fullContent class="mb-0">
        <!-- @row-click="openModalItem" -->
        <div class="px-4 py-3">
            <gofix-button :label="!item ? 'Add' : 'Edit'" @click="openModalItem"></gofix-button>
        </div>
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            ref="gofixTable">
            <template slot="gofix_table:weightage" slot-scope="row">
                {{ row.item.weightage ? `${row.item.weightage}%` : '0%' }}
            </template>
            <template slot="gofix_table:bottom-row" slot-scope="row" v-if="tableItems.length">
                <td class="text-nowrap" :key="i" v-for="(field, i) in row.data.fields">
                    <div class="total-header" v-if="field.key === 'assessment_type'">
                        <p class="mb-0">
                            <strong>Total</strong>
                        </p>
                    </div>
                    <span v-if="field.key === 'weightage'">
                        <strong>{{ `${total_percent}%` }}</strong>
                    </span>
                </td>
            </template>
        </gofix-table>
        <b-modal :no-close-on-backdrop="true" id="modal-create-orders" :title="modal.title" hide-footer :centered="true" v-model="modal.open" ref="modal-create-orders">
                <b-form class="formV2">
                    <gofix-form-input-number
                        label="	Inspection by Property Officers"
                        v-model="modal.data.inspection_by_po"
                        :integer-limit="3"
                        suffix="%">
                    </gofix-form-input-number>
                    <gofix-form-input-number
                        label="Maintenance Regime"
                        v-model="modal.data.maintenance_regime"
                        :integer-limit="3"
                        suffix="%">
                    </gofix-form-input-number>
                    <gofix-form-input-number
                        label="Other sources"
                        v-model="modal.data.other_sources"
                        :integer-limit="3"
                        suffix="%">
                    </gofix-form-input-number>
                </b-form>
                <b-button-group class="d-block text-right pr-4">
                    <gofix-button label="SUBMIT" @click="saveItem" :loading="modal.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
    </gofix-card>
</template>
<script>
export default {
    name: 'performance_assesment_performance_computation',
    props: {
        propertyType: {
            type: String,
            default: '',
        },
        contract: {
            type: Object,
            default: () => null,
        }
    },
    data() {
        return {
            tableConfig:{
                name: 'performance-assesment-performance-computation',
                controls:{
                    create: false,
                    update: false,
                    delete: false,
                    reload: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    tablePagination: false,
                    tableFilter: false
                },
                filter: {
                    contract_id: {type: "number", value: null, function:"=", with: []},
                    property_type: {type: "text", value: "", function:"ilike", with: []},
                },
                page: 1,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
                fields: [
                    {
                        key: 'id',
                        label: 'No',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:100px",
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'assessment_type',
                        label: 'Assessment Type',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:300px",
                        sorting: false,
                    },
                    {
                        key: 'weightage',
                        label: 'Weightage (%)',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                    },
                ]
            },
            tableItems: [],
            item: null,
            total_percent: 0,
            supplier_contracts: [],
            modal: {
                title: '',
                open: false,
                loading: false,
                options: {
                    assessment_types: ['Inspection by Property Officers', 'Maintenance Regime', 'Other sources']
                },
                data: {
                    contract_id: null,
                    property_type: null,
                    inspection_by_po: null,
                    maintenance_regime: null,
                    other_sources: null,
                }
            },
            timer: {
                save: null
            }
        }
    },
    watch: {
        propertyType: function() {
            this.$refs.gofixTable.reloadTableItems();
        },
        contract: function() {
            this.$refs.gofixTable.reloadTableItems();
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve,reject } = await callback();
            if(!this.contract || !this.propertyType) {
                this.tableItems = []
                this.tableConfig.total = 0
                resolve({
                    items: [],
                    total: 0
                })
                return
            }
            tableRequest.filter.property_type.value = this.propertyType
            tableRequest.filter.contract_id.value = this.contract.id
            tableRequest.type_setting = 'pa_performance_setting'
            await this.$store.dispatch("PerformanceAssesmentSettingsController/getItems", tableRequest)
            .then(response => {
                let arrTmp = [];
                this.item = null
                this.total_percent = 0
                if(response.items.length) {
                    this.item = response.items[0]
                    let index = 1
                    for (const [key, value] of Object.entries(response.items[0])) {
                        if(['inspection_by_po', 'maintenance_regime', 'other_sources'].includes(key)) {
                            this.total_percent += Number(value);
                            let name = 'Inspection by Property Officers'
                            if(key == 'maintenance_regime') name = 'Maintenance Regime'
                            if(key == 'other_sources') name = 'Other sources'
                            arrTmp.push({
                                id: index,
                                assessment_type: name,
                                weightage: value,
                            })
                            index++;
                        }
                    }
                }
                this.tableItems = arrTmp;
                this.tableConfig.total = arrTmp.length;
                resolve(response);
            })
            .catch(err => {
                this.$alertNotification("Can not load the performance computation", "danger");
                reject();
            })
        },
        async openModalItem(){
            if(this.item) {
                this.modal.title = 'Edit Performance Computation'
                this.modal.data = Object.assign(this.modal.data, this.item)
            } else {
                if(!this.propertyType) return this.$alertNotification("Please select a property type", "danger");
                if(!this.contract) return this.$alertNotification("Please select a supplier contract", "danger");
                this.modal.title = 'Create Performance Computation'
                this.modal.data = {
                    contract_id: this.contract.id,
                    property_type: this.propertyType,
                    inspection_by_po: null,
                    maintenance_regime: null,
                    other_sources: null,
                }
            }

            this.modal.open = true;
        },
        saveItem() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(() => {
                if(!this.modal.data.inspection_by_po) return this.$alertNotification("Inspection by property officers is required", "danger")
                if(!this.modal.data.maintenance_regime) return this.$alertNotification("Maintenance regime is required", "danger")
                if(!this.modal.data.other_sources) return this.$alertNotification("Other sources is required", "danger")

                const request = {
                    id: this.modal.data.id || null,
                    property_type: this.modal.data.property_type,
                    contract_id: this.modal.data.contract_id,
                    inspection_by_po: this.$accounting.unformat(this.modal.data.inspection_by_po),
                    maintenance_regime: this.$accounting.unformat(this.modal.data.maintenance_regime),
                    other_sources: this.$accounting.unformat(this.modal.data.other_sources),
                    type_setting: 'pa_performance_setting'
                }

                const total = Number(request.inspection_by_po) + Number(request.maintenance_regime) + Number(request.other_sources);
                if(total > 100) {
                    return this.$alertNotification("Total weightage must be less than or equal to 100%", "danger")
                }

                if(this.modal.loading) return
                this.modal.loading = true

                this.$store.dispatch(`PerformanceAssesmentSettingsController/savePASettings`, request)
                    .then(response => {
                        this.modal.loading = false
                        this.modal.open = false
                        this.$refs.gofixTable.reloadTableItems();
                        this.$alertNotification(this.$notificationV2(!request.id ? 'adding' : 'editing', 'pa_maintenance_weight'));
                    })
                    .catch(err => {
                        console.log(err)
                        this.modal.loading = false
                        if (err.response.data.error && err.response.data.error.message) {
                            this.$alertNotification(err.response.data.error.message, "danger")
                        }
                    })
            }, 200)
        }
    }
}
</script>